import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RememberService } from 'src/app/services/remember.service';
import { ForgotConfirmationComponent } from '../../forgot-confirmation/forgot-confirmation.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-rvs-confirmation-code',
  templateUrl: './rvs-confirmation-code.component.html',
  styleUrl: './rvs-confirmation-code.component.scss'
})
export class RvsConfirmationCodeComponent {
  confirmationNo;
  emailAddress;
  rememberme=false;
  foundcookie=false;
  isSubmitting=false;
  isFormCompleted=false;
  errorMsg;
  constructor(
    private rememberService: RememberService,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private enrollmentService: EnrollmentService,
    private navigationService: NavigationService){
    let member = this.rememberService.getCookie();
    if(member){
      console.log(member);
      this.rememberme = true;
      this.foundcookie = true;
      this.confirmationNo = member.confcode;
      this.emailAddress = member.email;
    }
  }

  openForgotConf(): void {
    this.dialog.open(ForgotConfirmationComponent, { panelClass: 'forgot-dialog-container' });
  }

  forward(){
    if(!this.isSubmitting){
      this.isSubmitting =true;
      const creds: any = {};
      this.isFormCompleted = true;
      if(this.foundcookie && !this.rememberme){
        this.rememberService.deleteCookie();
      }
      if (this.confirmationNo && this.emailAddress) {
        creds.confirmationCode = this.confirmationNo;
        creds.emailAddress = this.emailAddress;
        this.authenticationService.rvsLogin(creds).then(() => {
          //  authService resolved
          this.enrollmentService.rvsGetEnrollment().then(() => {
            if(!this.foundcookie && this.rememberme){
              this.rememberService.setCookie(this.confirmationNo, this.emailAddress);
            }
            // enrollmentService resolved
            this.navigationService.forwardrvs();
          });
        }, (err) => {
          this.isSubmitting =false;
          this.errorMsg = err;
        });
      } else {
        this.isSubmitting =false;
        this.errorMsg =
          'Enter your email address with your confirmation number.';
      }
    } 
  }
}
